import ProductPageLayout from '@/pages/products/components/ProductPageLayout';

export default function SalmonPage() {
  return (
    <ProductPageLayout>
      <div className="relative">
        {/* Page background */}
        <div className="fixed inset-0 z-0 pointer-events-none">
          
        </div>

        {/* Content section */}
              <section className="relative z-10 w-full">
                  {/* Background */}
                  <div className="absolute inset-0 z-0 overflow-hidden">
                      <img
                          src="/images/k2.png"
                          alt="Slide7"
                          className="w-full h-full object-cover object-center blur-md scale-105"
                      />


                      <div className="absolute inset-0 bg-black/50"></div>
                  </div>

          <div className="relative z-10 w-full max-w-[980px] mx-auto px-6 md:px-10 py-10">
            {/* Script tagline */}
            <p className="font-script text-white text-lg md:text-xl text-center mb-4">
              America&#39;s One-Stop-Shop for Seafood
            </p>

            {/* Header Image + H1 - source DOM has image before H1 */}
            <div className="flex flex-col md:flex-row items-start justify-between gap-4 md:gap-8 mb-2">
              <div className="flex-shrink-0 order-2 md:order-1">
                <img
                                  src="/images/po2.png"
                  alt="Product Header Salmon"
                  className="w-[600px] max-w-full h-auto"
                />
              </div>
              <h1 className="font-heading text-white text-5xl md:text-6xl lg:text-7xl tracking-[0.2em] leading-none uppercase order-1 md:order-2">
                Wholesale<br />SALMON
              </h1>
            </div>

            {/* Subheading */}
            <h5 className="font-heading text-white text-lg md:text-xl tracking-[0.15em] leading-snug mb-6 uppercase">
              Wholesale SALMON<br />from Finest Kind Seafood LLC
            </h5>

            {/* First paragraph - font_7 equivalent */}
            <p className="text-white text-sm leading-relaxed mb-6">
              FKS is a world class purveyor of fresh Atlantic Salmon, and offer the most exclusive salmon product&#39;s in the world with our exclusive brand, Perfekt Salmon. When it comes to our wholesale salmon, we decided from the start that we would only sell the very best and most consistent product on the market. That is why we went to the icy fjords surrounding the island of Froya in northern Norway, where we formed a partnership with a select group of farmers who habitually pay the extra attention to detail critical for producing the highest quality Atlantic salmon on the market. The result is a smoother-flavored, richer tasting salmon that is prized by chefs and general consumers alike.
            </p>

            {/* Paragraph 2 */}
            <p className="text-white text-[13px] leading-relaxed mb-5">
              Our wholesale salmon is available in three product forms: whole, filleted, and portioned. Our fillet option, however, is the bread and butter of our fresh salmon division. The FKS Custom D-Trim is a true-to-the-weight d-trim fillet that leaves you with no added fat or waste needed to be removed – therefore delivering 100% useable product and consistent yields. We offer our whole salmon, on the other hand, in size increments of 9/11 pounds, 11/13 pounds, 13/15 pounds, and 15/17 pounds. Finally, the standard order in our portion program is salmon portions between 4-10 ounces, but our laser precision machinery will custom cut portions to whatever sizes best fit your needs.
            </p>

            {/* Paragraph 3 */}
            <p className="text-white text-[13px] leading-relaxed mb-5">
              Aside from these options, we also offer a selection of organic wholesale salmon products. This line is the same Norwegian salmon as our regular salmon products, and includes both whole and our custom d-trim fillet options, though it also includes the following additional key features: organically certified; robust sustainability and environmental credentials; responsible sourcing of all ingredients; optimized nutritional specification; predominantly marine feeding pellets that utilizes a sustainable source of organically approved trimmings and fish meals/oils; and no growth promoters or antibiotics.
            </p>

            <p className="text-white text-[13px] leading-relaxed mb-5">
              We also offer Chilean, Canadian, Faroe, King, Coho, etc. Every customer is different and some prefer price over quality, or wild versus farm raised, so we do our best to offer a very wide variety of salmon products, but it&#39;s hard to compare them all to our Perfekt Salmon.
            </p>

            {/* Zoom image + remaining paragraphs */}
            <div className="relative">
              <img
                              src="/images/po1.png"
                alt="Wholesale Salmon Zoom"
                className="float-right ml-6 mb-4 w-[260px] md:w-[378px] h-auto"
              />
              <p className="text-white text-[13px] leading-relaxed mb-5">
                So what sets FKS Norwegian Atlantic salmon apart from the rest of the salmon industry? Our fillets are cut pre-rigor in Norway and flown to our facility the very same day, where we remove the pin bones in-house, custom trim each fillet, grade, and pack our fresh product. We guarantee our customers the highest quality salmon on the market because we hand select each fillet, opposed to merely swapping boxes. Additionally, we guarantee our customers the most consistent product on the market because we maintain steady supply seven days a week, three-hundred and sixty-five days a year.
              </p>
              <div className="clear-both" />
            </div>

            {/* Final paragraph */}
            <p className="text-white text-[13px] leading-relaxed mb-10">
              It is our goal to be your premier seafood wholesaler, which is why we harp on ecologically responsible fishing/farming practices and overall fresh, sustainable seafood. In that respect, not only are we HAACP certified, but our partners in Norway are also approved for the following standards: (1) BRC, (2) Global G.A.P.; (3) Debio (Organic production); (4) BAP (Best Aquaculture Practices); and (5) Kosher. That means our fresh salmon is raised in sustainable, healthy, ocean farmed conditions and is absolutely never exposed to GMO&#39;s (genetically modified organisms). Our Norwegian salmon is truly a top-shelf product that our customers can bank on day-in and day-out.
            </p>
          </div>
        </section>
      </div>
    </ProductPageLayout>
  );
}